export default "__VITE_ASSET__Bttc4jU8__"